// import React, { useEffect, useRef, useState, useContext } from "react";
// import { Link, useHistory, useLocation } from "react-router-dom";
// import Swal from "sweetalert2";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { BsPerson, BsPencilSquare, BsCheckCircleFill } from 'react-icons/bs';
// import { LuIndianRupee } from "react-icons/lu";
// import { apiRequest } from "../../apiService/allApi";
// import Rightcontainer from "../Components/Rightcontainer";
// import { MdOutlineLogout } from "react-icons/md";

// // Keep your CSS imports
// import "../css/layout.css";
// import css from "../css/Profile.module.css";
// import "../css/kyc.css";
// import "../css/Loader.css";

// const Profile1 = ({ profile }) => {
//   // --- KEEPING ALL YOUR EXISTING LOGIC & STATE UNTOUCHED ---
//   const translations = {
//     hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
//     en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
//   };

//   const { language } = useContext(LanguageContext);
//   const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const [show, setShow] = useState(false);
//   const [show1, setShow1] = useState(false);
//   const handleClose = () => setShow1(false);
//   const handleShow = () => setShow1(true);
//   const [referral, setCode] = useState("");
//   const [Id, setId] = useState(null);
//   const [msg, setMsg] = useState("");
//   const [portcss, setPortcss] = useState(css.active_tab);
//   const [portcss1, setPortcss1] = useState(css.inactive_tab);
//   const [holder_name, setHolder_name] = useState();
//   const [account_number, setAccount_number] = useState();
//   const [ifsc_code, setIfsc_code] = useState();
//   const [upi_id, setUpi_id] = useState();
//   const [isLoading, setIsloading] = useState(false);
//   const [showKyc, setShowKyc] = useState(false);
//   const [process1, setProcesss] = useState(false);

//   const udata = localStorage.getItem("udata");
//   const profileData = JSON.parse(udata);
//   const siteData = localStorage.getItem("sitSetting");
//   const SData = JSON.parse(siteData);
//   const handleCloseKyc = () => setShowKyc(false);
//   const handleShowKyc = () => setShowKyc(true);
//   const [inputOpen, setInputOpen] = useState(false);
//   const [Email, setEmail] = useState(null);
//   const toggleInput = () => setInputOpen(!inputOpen);
//   const history = useHistory();
//   const location = useLocation();
//   // --- ALL YOUR FUNCTIONS (NOT MODIFIED) ---
//   const logout = async () => {
//     localStorage.clear();
//     let access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     await apiRequest(`me`, "GET", null, headers)
//       .then(() => { /* logic */ })
//       .catch((e) => {
//         if (e.response?.status === 401) {
//           localStorage.removeItem("token");
//           window.location.reload();
//           history.push("/login");
//         }
//       });
//   };

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);

//     if (params.get("kyc") === "true") {
//       setShowKyc(true);
//     }
//   }, [location.search]);

//   const UpdateEmail = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     if (Email != null) {
//       try {
//         const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
//         if (respone.data.status === false) {
//           Swal.fire({ title: respone.data.msg, icon: "error" });
//         } else {
//           setEmail(respone.data); setInputOpen(false);
//           Swal.fire({ title: respone.data.msg, icon: "success" });
//         }
//       } catch (error) { }
//     } else {
//       Swal.fire({ title: "Please enter your Email", icon: "error" });
//     }
//   };

//   const [Name, setName] = useState(null);
//   const UpdateProfile = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     if (Name != null) {
//       const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
//       if (respone.data.status === false) {
//         Swal.fire({ title: respone.data.msg, icon: "error" });
//       } else {
//         setName(respone.data);
//         Swal.fire({ title: respone.data.msg, icon: "success" });
//       }
//     }
//   };

//   const [total, setTotal] = useState();
//   const TotalGame = async () => {
//     let access_token = localStorage.getItem("token");
//     let userId = localStorage.getItem("userId");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     try {
//       const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
//       if (res.data) setTotal(res.data);
//     } catch (e) { }
//   };

//   const Result = async (file) => {
//     if (file) {
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const formData = new FormData();
//       formData.append("avatar", file);
//       await apiRequest(`users/me/avatar`, "POST", formData, headers);
//     }
//   };

//   const Kyc = () => setShowKyc(true);

//   const [AadharNum, setAadharNum] = useState("");
//   const [userAdharData, setUserAdharData] = useState("");
//   const handleAdharChnage = (e) => setAadharNum(e.target.value);

//   const AdharNumber = async (e) => {
//     setIsloading(true); e.preventDefault();
//     if (/^[0-9]{12}$/.test(AadharNum)) {
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const data = { aadharNumber: AadharNum };
//       try {
//         const res = await apiRequest("aadharcard-auto", "POST", data, headers);
//         setUserAdharData(res?.data);
//         setIsloading(false);
//         if (res.data.status === false) setMsg(res?.data?.msg);
//         else setMsg(res?.data?.data?.message);
//       } catch (error) { console.log(error); }
//     } else {
//       Swal.fire({ icon: "error", title: "Invalid Aadhar", text: "12-digit required" });
//       setIsloading(false);
//     }
//   };

//   const [AadharOtp, setAadharOtp] = useState("");
//   const [isLoading1, setIsloading1] = useState(false);
//   const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

//   const AdharOtpFunc = async (e) => { // Renamed slightly to avoid collision with state
//     setIsloading1(true);
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     const data = { aadharNumber: AadharNum, otp: AadharOtp, Email: Email, request_id: userAdharData?.request_id, };
//     try {
//       const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
//       setIsloading1(false);
//       if (res.data.status === false) setMsg(res.data?.msg);
//       else window.location.reload();
//     } catch (e) { console.log(e); }
//   };

//   let aadharProcess = useRef(false);
//   const [Names, setNames] = useState("");
//   const [DOB, setDob] = useState("");
//   const [frontLoaded, setFrontLoaded] = useState(null);
//   const [backLoaded, setBackLoaded] = useState(null);

//   const handleSubmitdata = async (e) => {
//     e.preventDefault();
//     if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
//       alert("All fields required"); return;
//     }
//     if (aadharProcess.current === false) {
//       setProcesss(true); aadharProcess.current = true;
//       const formData = new FormData();
//       formData.append("Name", Names); formData.append("DOB", DOB);
//       formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
//       formData.append("Number", AadharNum); formData.append("Email", Email);
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const res = await apiRequest(`aadharcard`, "POST", formData, headers);
//       if (res.data.status === false) {
//         Swal.fire({ title: res.data.msg, icon: "error" }).then(() => handleCloseKyc());
//       } else {
//         Swal.fire({ title: "KYC submitted", icon: "success" }).then(() => handleCloseKyc());
//         history.push("/Profile");
//       }
//       aadharProcess.current = false; setProcesss(false);
//     }
//   };

//   useEffect(() => { TotalGame(); }, []);

//   const [isValidEmail, setIsValidEmail] = useState(true);
//   const handleEmailChange = (e) => {
//     const newEmail = e.target.value;
//     setEmail(newEmail);
//     const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
//     setIsValidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
//   };

//   const theme = localStorage.getItem('theme');
//   const styles = {
//     backgroundColor: theme === 'light' ? '#f0f2f5' : '#0f0f1b',
//     color: theme === 'light' ? '#333' : '#fff',
//   };

//   // --- NEW UI RENDERING ---
//   return (
//     <>
//       <div className="leftContainer " >
//         <div className="profile_page_new ">

//           <div className="mlk_profile_master_card mb-4">

//             {/* <div className="mlk_profile_border_glow"></div> */}

//             {/* PROFILE AREA */}

//             <div className="mlk_profile_top_section">

//               <div className="mlk_profile_avatar_wrapper">

//                 <label style={{ cursor: "pointer" }}>

//                   <input
//                     type="file"
//                     className="d-none"
//                     accept="image/*"
//                     onChange={(e) => Result(e.target.files[0])}
//                   />

//                   <div className="mlk_profile_avatar_ring">

//                     <img
//                       src={
//                         profileData?.avatar
//                           ? `${baseUrl}/${profileData.avatar}`
//                           : "./images/avatars/Avatar5.png"
//                       }
//                       alt=""
//                       className="mlk_profile_avatar"
//                     />

//                   </div>

//                   <div className="mlk_profile_edit_btn">
//                     <BsPencilSquare size={12} />
//                   </div>

//                 </label>

//               </div>

//               <div className="mlk_profile_user_area">

//                 {portcss === css.active_tab ? (
//                   <>
//                     <div className="d-flex align-items-center">

//                       <h2 className="mlk_profile_username">
//                         {profile?.Name || "Player"}
//                       </h2>

//                       <BsPencilSquare
//                         className="mlk_profile_name_edit"
//                         onClick={() => {
//                           setPortcss(css.inactive_tab);
//                           setPortcss1(css.active_tab);
//                         }}
//                       />

//                     </div>

//                     <div className="mlk_profile_rank_badge">
//                       ☆ PRO GAMER
//                     </div>
//                   </>
//                 ) : (
//                   <div className="d-flex align-items-center">

//                     <div className="mlk_edit_name_wrapper">

//                       <input
//                         type="text"
//                         className="mlk_profile_name_input"
//                         value={Name}
//                         onChange={(e) => setName(e.target.value)}
//                       />

//                       <button
//                         className="mlk_profile_save_btn"
//                         onClick={() => {
//                           setPortcss(css.active_tab);
//                           setPortcss1(css.inactive_tab);
//                           UpdateProfile();
//                         }}
//                       >
//                         <BsCheckCircleFill />
//                       </button>

//                     </div>

//                   </div>
//                 )}

//               </div>

//               <div className="mlk_profile_kyc_area">

//                 {profile?.verified === "verified" ? (
//                   <span className="mlk_verified_badge">
//                     ✓ VERIFIED
//                   </span>
//                 ) : (
//                   <span
//                     className="mlk_unverified_badge"
//                     onClick={Kyc}
//                   >
//                     ! UNVERIFIED
//                   </span>
//                 )}

//               </div>

//             </div>

//             {/* STATS */}

//             <div className="mlk_stats_wrapper">

//               <div className="mlk_stat_card blue">

//                 <div className="mlk_stat_icon_wrap">
//                   <img src="/images/crossswords.png" alt="" />
//                 </div>

//                 <div>
//                   <div className="mlk_stat_title">
//                     {translations[language].game}
//                   </div>

//                   <div className="mlk_stat_value">
//                     {String(total?.stringValue ?? total ?? "0")}
//                   </div>
//                 </div>

//               </div>

//               <div className="mlk_stat_card gold">

//                 <div className="mlk_stat_icon_wrap">
//                   <img src="../images/troffee.png" alt="" />
//                 </div>

//                 <div>
//                   <div className="mlk_stat_title">
//                     {translations[language].Win}
//                   </div>

//                   <div className="mlk_stat_value">
//                     ₹{String(profile?.wonAmount?.stringValue ?? "0")}
//                   </div>
//                 </div>

//               </div>

//             </div>

//           </div>

//           {/* 3. Account Details List */}
//           <div className="mlk_details_main_card mb-4">

//             <div className="mlk_details_title_wrap">
//               <span className="mlk_title_line"></span>

//               <h4 className="mlk_details_title">
//                 GENERAL DETAILS
//               </h4>

//               <span className="mlk_title_line"></span>
//             </div>

//             {/* Phone */}

//             <div className="mlk_detail_item">

//               <div className="mlk_detail_left">

//                 <div className="mlk_detail_icon phone">
//                   <img src="/images/phone.png" alt="" />
//                 </div>

//                 <div className="mlk_detail_content">
//                   <span>Phone Number</span>
//                   <h6>{profile?.Phone}</h6>
//                 </div>

//               </div>

//             </div>

//             {/* Email */}

//             <div className="mlk_detail_item">

//               <div className="mlk_detail_left">

//                 <div className="mlk_detail_icon email">
//                   <img src="/images/mail.png" alt="" />
//                 </div>

//                 <div className="mlk_detail_content">
//                   <span>Email ID</span>
//                   <h6>{profile?.Email || "Not Updated"}</h6>
//                 </div>

//               </div>

//               <div
//                 className="mlk_detail_action"
//                 onClick={toggleInput}
//               >
//                 <BsPencilSquare />
//               </div>

//             </div>

//             {inputOpen && (
//               <div className="mlk_email_update_box">

//                 <input
//                   type="email"
//                   className="mlk_email_input"
//                   placeholder="New Email Address"
//                   value={Email}
//                   onChange={handleEmailChange}
//                 />

//                 <button
//                   className="mlk_email_update_btn"
//                   onClick={UpdateEmail}
//                 >
//                   Update Email
//                 </button>

//               </div>
//             )}

//             {/* KYC */}

//             <div
//               className="mlk_detail_item"
//               onClick={
//                 profile?.verified === "verified" ||
//                   profile?.verified === "pending"
//                   ? null
//                   : Kyc
//               }
//               style={{
//                 cursor:
//                   profile?.verified === "verified" ||
//                     profile?.verified === "pending"
//                     ? "default"
//                     : "pointer"
//               }}
//             >

//               <div className="mlk_detail_left">

//                 <div className="mlk_detail_icon kyc">
//                   <img src="/images/kyc.png" alt="" />
//                 </div>

//                 <div className="mlk_detail_content">
//                   <span>KYC Status</span>

//                   <h6
//                     className={
//                       profile?.verified === "verified"
//                         ? "mlk_kyc_verified"
//                         : profile?.verified === "pending"
//                           ? "mlk_kyc_pending"
//                           : "mlk_kyc_unverified"
//                     }
//                   >
//                     {profile?.verified === "verified"
//                       ? "Verified"
//                       : profile?.verified === "pending"
//                         ? "Pending Verification"
//                         : "Complete KYC Verification"}
//                   </h6>

//                 </div>

//               </div>

//               {profile?.verified !== "verified" &&
//                 profile?.verified !== "pending" && (
//                   <div className="mlk_detail_arrow">
//                     ›
//                   </div>
//                 )}

//             </div>

//           </div>

//           <div className="logout_container text-center">
//             <button className="mlk_logout_btn" onClick={logout}>
//               <MdOutlineLogout />
//               <span>LOGOUT ACCOUNT</span>
//             </button>
//           </div>
//         </div>

//         {/* --- MODAL (Functionality Untouched, UI Cleaned) --- */}
//         <Modal show={showKyc} onHide={handleCloseKyc} centered className="malik_kyc_modal">
//           <Modal.Header closeButton className="border-0">
//             <Modal.Title style={{ color: "#000" }}>Verification Center</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="pt-0">
//             <ul className="nav nav-pills malik_kyc_tabs mb-3" id="kycTab" role="tablist">
//               {SData?.onlineKYC && (
//                 <li className="nav-item flex-fill">
//                   <button className="nav-link active w-100" id="online-tab" data-bs-toggle="tab" data-bs-target="#online">Online</button>
//                 </li>
//               )}
//               {SData?.offlineKYC && (
//                 <li className="nav-item flex-fill">
//                   <button className="nav-link w-100" id="offline-tab" data-bs-toggle="tab" data-bs-target="#offline"> Offline Kyc</button>
//                 </li>
//               )}
//             </ul>

//             <div className="tab-content mt-4">
//               {SData.onlineKYC && (
//                 <div className="tab-pane fade show active" id="online">
//                   <div className="form-group mb-3">
//                     <label className="small text-secondary">Aadhar Number</label>
//                     <input type="number" className="modern_input" value={AadharNum} onChange={handleAdharChnage} placeholder="12 Digit Aadhar" />
//                     <p className="text-danger small mt-1">{msg}</p>
//                   </div>
//                   {isLoading ? <div className="text-center"><img src='/images/LandingPage_img/loader1.gif' width="40" /></div> :
//                     !userAdharData?.request_id && <button className="btn_premium_modal w-100" onClick={AdharNumber}>Send OTP</button>
//                   }
//                   {userAdharData?.request_id && (
//                     <div className="mt-3">
//                       <input type="number" className="modern_input" value={AadharOtp} onChange={handleAdharOtpChnage} placeholder="Enter OTP" />
//                       <button className="btn_premium_modal w-100 mt-2" onClick={AdharOtpFunc}>Submit OTP</button>
//                     </div>
//                   )}
//                 </div>
//               )}
//               {SData.offlineKYC && (
//                 <div className="tab-pane fade" id="offline">
//                   <input type="text" className="malik_kyc_input" placeholder="Full Name" value={Names} onChange={(e) => setNames(e.target.value)} />
//                   <input type="text" className="malik_kyc_input" placeholder="Aadhar Number" value={AadharNum} onChange={handleAdharChnage} />
//                   <input type="date" className="malik_kyc_input" value={DOB} onChange={(e) => setDob(e.target.value)} />
//                   <div className="malik_upload_box mb-3">
//                     <label>Front Photo</label>
//                     <input type="file" onChange={(e) => setFrontLoaded(e.target.files)} accept="image/*" />
//                   </div>
//                   <div className="malik_upload_box mb-3">
//                     <label>Back Photo</label>
//                     <input type="file" onChange={(e) => setBackLoaded(e.target.files)} accept="image/*" />
//                   </div>
//                   <button className="malik_kyc_btn w-100" onClick={handleSubmitdata}>Submit Verification</button>
//                 </div>
//               )}
//             </div>
//           </Modal.Body>
//         </Modal>
//       </div>

//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>

//       <style dangerouslySetInnerHTML={{
//         __html: `
//         .premium_card { background: #1a1a2e; border-radius: 15px; position: relative; overflow: hidden; border: 1px solid #2a2a45; box-shadow: 0 10px 30px rgba(0,0,0,0.5); }
//         .card_accent { position: absolute; top:0; left:0; width: 100%; height: 4px; background: linear-gradient(90deg, #f39c12, #e67e22); }
//         .main_profile_img { width: 70px; height: 70px; border-radius: 50%; border: 3px solid #f39c12; object-fit: cover; }
//         .camera_badge { position: absolute; bottom: 0; right: 0; background: #f39c12; border-radius: 50%; padding: 4px; border: 2px solid #1a1a2e; }
//         .profile_name_text { font-size: 1.2rem; font-weight: 700; color: #fff; margin-left: 10px; }
//         .badge_verified { background: rgba(46, 204, 113, 0.2); color: #2ecc71; border: 1px solid #2ecc71; padding: 4px 10px; border-radius: 20px; font-size: 10px; font-weight: 800; }
//         .badge_pending { background: rgba(231, 76, 60, 0.2); color: #e74c3c; border: 1px solid #e74c3c; padding: 4px 10px; border-radius: 20px; font-size: 10px; font-weight: 800; cursor:pointer; }
//         .stats_grid_premium { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; }
//         .stat_item { background: #1a1a2e; padding: 15px; border-radius: 12px; display: flex; align-items: center; border: 1px solid #2a2a45; }
//         .stat_item img { width: 35px; height: 35px; margin-right: 12px; }
//         .stat_label { font-size: 10px; color: #888; text-transform: uppercase; display: block; }
//         .stat_val { font-size: 1.1rem; font-weight: 800; margin: 0; color: #fff; }
//         .blue_glow { border-left: 4px solid #3498db; }
//         .gold_glow { border-left: 4px solid #f1c40f; }
//         .green_glow { border-left: 4px solid #2ecc71; }
//         .purple_glow { border-left: 4px solid #9b59b6; }
//         .account_details_card { background: #000; border-radius: 15px; border: 1px solid #2a2a45; }
//         .section_title { font-size: 0.9rem; font-weight: 700; color: #f39c12; text-transform: uppercase; margin-bottom: 15px; }
//         .detail_row { padding: 12px 0; border-bottom: 1px solid #2a2a45; }
//         .row_icon { width: 40px; height: 40px; background: #252545; border-radius: 10px; display: flex; align-items: center; justify-content: center; }
//         .row_content label { font-size: 10px; color: #888; margin:0; }
//         .row_content p { font-size: 14px; color: #fff; margin:0; font-weight: 600; }
//         .modern_input { background: #ffff; border: 1px solid #2a2a45; color: #000; padding: 10px; border-radius: 8px; width: 100%; outline: none; transition: 0.3s; }
//         .modern_input:focus { border-color: #f39c12; box-shadow: 0 0 10px rgba(243, 156, 18, 0.2); }
//         .premium_logout_btn { background: linear-gradient(90deg, #e74c3c, #c0392b); color: #fff; border: none; padding: 12px 40px; border-radius: 30px; font-weight: 800; letter-spacing: 1px; width: 80%; transition: 0.3s; }
//         .premium_logout_btn:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(231, 76, 60, 0.4); }
//         .modern_tabs .nav-link { background: #0f0f1b; color: #888; border: 1px solid #2a2a45; margin: 0 5px; font-size: 14px; font-weight: 600; }
//         .modern_tabs .nav-link.active { background: #f39c12 !important; color: #fff; border-color: #f39c12; }
//         .btn_premium_modal { background: #f39c12; color: #fff; border: none; padding: 10px; border-radius: 8px; font-weight: 700; }
//         .dark_modal .modal-content { background: #1a1a2e; color: #fff; border: 1px solid #2a2a45; border-radius: 20px; }
//         .file_upload_area { border: 2px dashed #2a2a45; padding: 10px; border-radius: 10px; text-align: center; }
//         .file_upload_area label { font-size: 12px; color: #f39c12; display: block; }
//       `}} />
//     </>
//   );
// };

// export default Profile1;




import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { BsPerson, BsPencilSquare, BsCheckCircleFill, BsCheckCircle, BsClockHistory, BsXCircleFill, BsShieldFillCheck, BsShieldExclamation, BsList, BsCoin, BsCashStack, BsCalendar3, BsController, BsTrophyFill, BsTelephoneFill, BsEnvelopeFill, BsShieldLockFill, BsBellFill, BsHeadset, BsGearFill, BsChevronRight, BsWallet2, BsGiftFill, BsHouseDoorFill } from 'react-icons/bs';
import { LuIndianRupee } from "react-icons/lu";
import { apiRequest } from "../../apiService/allApi";
import Rightcontainer from "../Components/Rightcontainer";
import { MdOutlineLogout } from "react-icons/md";

// Keep your CSS imports
import "../css/layout.css";
import css from "../css/Profile.module.css";
import "../css/BoxLudoProfile.css";
import "../css/kyc.css";
import "../css/Loader.css";

import {
  ShieldCheck,
  UserRound,
  Fingerprint,
  IdCard,
  CalendarDays,
  Image as ImageIcon,
  UploadCloud,
  Send,
  LockKeyhole,
  FileText,
  CheckCircle2,
} from "lucide-react";
// import "../css/Profile1Premium.css";

const Profile1 = ({ profile }) => {
  // --- KEEPING ALL YOUR EXISTING LOGIC & STATE UNTOUCHED ---
  const translations = {
    hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
    en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
  };
  const [activeKycTab, setActiveKycTab] = useState("online");
  const { language } = useContext(LanguageContext);
  const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const handleClose = () => setShow1(false);
  const handleShow = () => setShow1(true);
  const [referral, setCode] = useState("");
  const [Id, setId] = useState(null);
  const [msg, setMsg] = useState("");
  const [portcss, setPortcss] = useState(css.active_tab);
  const [portcss1, setPortcss1] = useState(css.inactive_tab);
  const [holder_name, setHolder_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [isLoading, setIsloading] = useState(false);
  const [showKyc, setShowKyc] = useState(false);
  const [process1, setProcesss] = useState(false);

  const udata = localStorage.getItem("udata");
  const profileData = JSON.parse(udata);
  const siteData = localStorage.getItem("sitSetting");
  const SData = JSON.parse(siteData);
  const handleCloseKyc = () => setShowKyc(false);
  const handleShowKyc = () => setShowKyc(true);
  const [inputOpen, setInputOpen] = useState(false);
  const [Email, setEmail] = useState(null);
  const toggleInput = () => setInputOpen(!inputOpen);
  const history = useHistory();
  const location = useLocation();
  // --- ALL YOUR FUNCTIONS (NOT MODIFIED) ---
  const logout = async () => {
    localStorage.clear();
    let access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    await apiRequest(`me`, "GET", null, headers)
      .then(() => { /* logic */ })
      .catch((e) => {
        if (e.response?.status === 401) {
          localStorage.removeItem("token");
          window.location.reload();
          history.push("/login");
        }
      });
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get("kyc") === "true") {
      setShowKyc(true);
    }
  }, [location.search]);

  const UpdateEmail = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Email != null) {
      try {
        const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
        if (respone.data.status === false) {
          Swal.fire({ title: respone.data.msg, icon: "error" });
        } else {
          setEmail(respone.data); setInputOpen(false);
          Swal.fire({ title: respone.data.msg, icon: "success" });
        }
      } catch (error) { }
    } else {
      Swal.fire({ title: "Please enter your Email", icon: "error" });
    }
  };

  const [Name, setName] = useState(null);
  const UpdateProfile = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Name != null) {
      const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
      if (respone.data.status === false) {
        Swal.fire({ title: respone.data.msg, icon: "error" });
      } else {
        setName(respone.data);
        Swal.fire({ title: respone.data.msg, icon: "success" });
      }
    }
  };

  const [total, setTotal] = useState();
  const TotalGame = async () => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");
    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
      if (res.data) setTotal(res.data);
    } catch (e) { }
  };

  const Result = async (file) => {
    if (file) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const formData = new FormData();
      formData.append("avatar", file);
      await apiRequest(`users/me/avatar`, "POST", formData, headers);
    }
  };

  const Kyc = () => setShowKyc(true);

  const [AadharNum, setAadharNum] = useState("");
  const [userAdharData, setUserAdharData] = useState("");
  const handleAdharChnage = (e) => setAadharNum(e.target.value);

  const AdharNumber = async (e) => {
    setIsloading(true); e.preventDefault();
    if (/^[0-9]{12}$/.test(AadharNum)) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const data = { aadharNumber: AadharNum };
      try {
        const res = await apiRequest("aadharcard-auto", "POST", data, headers);
        setUserAdharData(res?.data);
        setIsloading(false);
        if (res.data.status === false) setMsg(res?.data?.msg);
        else setMsg(res?.data?.data?.message);
      } catch (error) { console.log(error); }
    } else {
      Swal.fire({ icon: "error", title: "Invalid Aadhar", text: "12-digit required" });
      setIsloading(false);
    }
  };

  const [AadharOtp, setAadharOtp] = useState("");
  const [isLoading1, setIsloading1] = useState(false);
  const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

  const AdharOtpFunc = async (e) => { // Renamed slightly to avoid collision with state
    setIsloading1(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    const data = { aadharNumber: AadharNum, otp: AadharOtp, Email: Email, request_id: userAdharData?.request_id, };
    try {
      const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
      setIsloading1(false);
      if (res.data.status === false) setMsg(res.data?.msg);
      else window.location.reload();
    } catch (e) { console.log(e); }
  };

  let aadharProcess = useRef(false);
  const [Names, setNames] = useState("");
  const [DOB, setDob] = useState("");
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);

  const handleSubmitdata = async (e) => {
    e.preventDefault();
    if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
      alert("All fields required"); return;
    }
    if (aadharProcess.current === false) {
      setProcesss(true); aadharProcess.current = true;
      const formData = new FormData();
      formData.append("Name", Names); formData.append("DOB", DOB);
      formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
      formData.append("Number", AadharNum); formData.append("Email", Email);
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const res = await apiRequest(`aadharcard`, "POST", formData, headers);
      if (res.data.status === false) {
        Swal.fire({ title: res.data.msg, icon: "error" }).then(() => handleCloseKyc());
      } else {
        Swal.fire({ title: "KYC submitted", icon: "success" }).then(() => handleCloseKyc());
        history.push("/Profile");
      }
      aadharProcess.current = false; setProcesss(false);
    }
  };

  useEffect(() => { TotalGame(); }, []);

  const [isValidEmail, setIsValidEmail] = useState(true);
  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    setIsValidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
  };

  const theme = localStorage.getItem('theme');
  const styles = {
    backgroundColor: theme === 'light' ? '#f0f2f5' : '#0f0f1b',
    color: theme === 'light' ? '#333' : '#fff',
  };

  // UI refreshed to match the supplied Box Ludo profile reference.
  const rawKycStatus = String(profile?.verified || "unverified").toLowerCase().trim();
  const kycStatus = rawKycStatus === "verified"
    ? "verified"
    : rawKycStatus === "pending"
      ? "pending"
      : ["rejected", "failed", "declined"].includes(rawKycStatus)
        ? "rejected"
        : "unverified";

  const kycDisplay = {
    verified: { title: "VERIFIED", subtitle: "Identity Confirmed", icon: BsShieldFillCheck },
    pending: { title: "VERIFICATION PENDING", subtitle: "Your KYC is under review", icon: BsClockHistory },
    unverified: { title: "VERIFY NOW", subtitle: "Complete your KYC", icon: BsShieldExclamation },
    rejected: { title: "VERIFICATION REJECTED", subtitle: "Please review your KYC", icon: BsXCircleFill },
  }[kycStatus];

  const KycStatusIcon = kycDisplay.icon;

  const memberSince = profile?.createdAt
    ? new Date(profile.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" })
    : "Jan 2024";

  return (
    <>
      <div className="leftContainer bl-profile-layout">
        <div className="profile_page_new bl-profile-page">



          {/* Profile hero */}
          <section className="bl-hero-card bl-animate-in">
            <div className="bl-avatar-column">
              {/* <label className="bl-avatar-upload" title="Change profile photo">
                <input type="file" className="d-none" accept="image/*" onChange={(e) => { const file = e.target.files?.[0]; if (file) Result(file); e.target.value = ""; }} />
                <span className="bl-avatar-ring">
                  <img src={profileData?.avatar ? `${baseUrl}/${profileData.avatar}` : "./images/avatars/Avatar5.png"} alt="Profile avatar" className="bl-avatar-img" />
                </span>
                <span className="bl-avatar-edit"><BsPencilSquare /></span>
              </label> */}
              <img src="/images/avatars/profile.png" alt="Profile avatar" className="bl-avatar-img" />
            </div>

            <div className="bl-user-details">
              {portcss === css.active_tab ? (
                <>
                  <div className="bl-user-name-row">
                    <h2 className="bl-user-name">{profile?.Name || "Player"}</h2>
                    <button type="button" className="bl-name-edit" aria-label="Edit name" onClick={() => { setPortcss(css.inactive_tab); setPortcss1(css.active_tab); }}><BsPencilSquare /></button>
                  </div>
                  {/* <div className="bl-rank-pill"><span>★</span> PRO GAMER</div> */}
                </>
              ) : (
                <div className="bl-name-editor">
                  <input type="text" className="bl-name-input" value={Name ?? ""} onChange={(e) => setName(e.target.value)} placeholder="Enter your name" />
                  <button type="button" className="bl-name-save" aria-label="Save name" onClick={() => { setPortcss(css.active_tab); setPortcss1(css.inactive_tab); UpdateProfile(); }}><BsCheckCircleFill /></button>
                </div>
              )}
              <div className="bl-member-date"><BsCalendar3 /><span>Member Since</span><strong>{memberSince}</strong></div>
            </div>

            {/* <div className={`bl-kyc-hero bl-kyc-${kycStatus}`} onClick={() => { if (kycStatus === "unverified" || kycStatus === "rejected") Kyc(); }} role={kycStatus === "verified" || kycStatus === "pending" ? undefined : "button"} tabIndex={kycStatus === "verified" || kycStatus === "pending" ? undefined : 0} onKeyDown={(e) => { if ((e.key === "Enter" || e.key === " ") && (kycStatus === "unverified" || kycStatus === "rejected")) { e.preventDefault(); Kyc(); } }}>
              <div className="bl-kyc-laurel" aria-hidden="true">❧</div>
              <div className="bl-kyc-shield"><KycStatusIcon className="bl-kyc-shield-icon" /></div>
              <div className="bl-kyc-ribbon">{kycDisplay.title}</div>
              <small className="bl-kyc-caption">{kycDisplay.subtitle}</small>
            </div> */}


            {/* KYC STATUS HERO */}
            <div
              className={`bl-kyc-hero bl-kyc-${kycStatus}`}
              onClick={() => {
                if (kycStatus === "unverified" || kycStatus === "rejected") {
                  Kyc();
                }
              }}
              role={
                kycStatus === "unverified" || kycStatus === "rejected"
                  ? "button"
                  : undefined
              }
              tabIndex={
                kycStatus === "unverified" || kycStatus === "rejected"
                  ? 0
                  : undefined
              }
              onKeyDown={(e) => {
                if (
                  (e.key === "Enter" || e.key === " ") &&
                  (kycStatus === "unverified" || kycStatus === "rejected")
                ) {
                  e.preventDefault();
                  Kyc();
                }
              }}
            >
              {/* VERIFIED */}
              {kycStatus === "verified" && (
                <div className="bl-kyc-status-content">
                  <img
                    src="/images/verified.png"
                    alt="KYC Verified"
                    className="bl-kyc-status-image"
                  />

                  {/* <div className="bl-kyc-status-text">
                    <span className="bl-kyc-status-badge">
                      <BsCheckCircle />
                      VERIFIED
                    </span>

                    <h3>Identity Verified!</h3>
                    <p>Your KYC verification is complete.</p>
                  </div> */}
                </div>
              )}

              {/* PENDING */}
              {/* {kycStatus === "pending" && (
                <div className="bl-kyc-status-content">
                  <img
                    src="/images/verified.png"
                    alt="KYC Pending"
                    className="bl-kyc-status-image"
                  />

                  <div className="bl-kyc-status-text">
                    <span className="bl-kyc-status-badge">
                      <BsClockHistory />
                      UNDER REVIEW
                    </span>

                    <h3>Verification Pending</h3>
                    <p>Your documents are being reviewed.</p>
                  </div>
                </div>
              )} */}

              {/* UNVERIFIED */}
              {kycStatus === "unverified" && (
                <div className="bl-kyc-status-content">
                  <img
                    src="/images/unverified.png"
                    alt="Complete KYC"
                    className="bl-kyc-status-image"
                  />

                  <div className="bl-kyc-status-text">

                    <button
                      type="button"
                      className="bl-kyc-complete-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        Kyc();
                      }}
                    >
                      Complete KYC
                      <BsChevronRight />
                    </button>
                  </div>
                </div>
              )}

              {/* REJECTED */}
              {/* {kycStatus === "rejected" && (
                <div className="bl-kyc-status-content">
                  <img
                    src="/images/kyc-rejected.png"
                    alt="KYC Rejected"
                    className="bl-kyc-status-image"
                  />

                  <div className="bl-kyc-status-text">
                    <span className="bl-kyc-status-badge">
                      VERIFICATION REJECTED
                    </span>

                    <h3>Verification Unsuccessful</h3>
                    <p>Please review your details and submit your KYC again.</p>

                    <button
                      type="button"
                      className="bl-kyc-complete-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        Kyc();
                      }}
                    >
                      Retry KYC
                      <BsChevronRight />
                    </button>
                  </div>
                </div>
              )} */}
            </div>

          </section>

          {/* Stats */}
          <section className="bl-stats-card bl-animate-in bl-delay-1">
            <div className="bl-stat-block">
              <div className="bl-stat-art bl-stat-battles"><img src="/images/battle-played.png" alt="" /></div>
              <div className="bl-stat-copy"><span>{translations[language]?.game || "Battle Played"}</span><strong>{String(total?.stringValue ?? total ?? "0")}</strong></div>
            </div>
            <div className="bl-stat-divider" />
            <div className="bl-stat-block">
              <div className="bl-stat-art bl-stat-trophy"><img src="../images/coin-won.png" alt="" /></div>
              <div className="bl-stat-copy"><span>{translations[language]?.Win || "Coin Won"}</span><strong>₹{String(profile?.wonAmount?.stringValue ?? "0")}</strong></div>
            </div>
          </section>


          {/* BOX LUDO - ACCOUNT INFORMATION */}
          <section className="bl-account-card bl-animate-in bl-delay-2">

            {/* Section Heading */}
            <div className="bl-section-heading">
              <span className="bl-heading-line" />

              <h3>
                <span className="bl-heading-diamond">◆</span>
                ACCOUNT INFORMATION
                <span className="bl-heading-diamond">◆</span>
              </h3>

              <span className="bl-heading-line" />
            </div>

            {/* PHONE NUMBER CARD */}
            <div className="bl-detail-row bl-phone-row">

              <div className="bl-detail-icon bl-phone-icon">
                <img src="https://cdn-icons-png.flaticon.com/128/1538/1538493.png" alt="" />
              </div>

              <div className="bl-detail-copy">
                <span>Phone Number</span>
                <strong>{profile?.Phone || "Not Updated"}</strong>
              </div>

              {/* Decorative background image */}
              <img
                src="/images/phone.png"
                alt=""
                aria-hidden="true"
                className="bl-row-bg-image bl-phone-bg-image"
              />

              <div className="bl-row-action bl-phone-action">
                <BsChevronRight />
              </div>

            </div>

            {/* EMAIL CARD */}
            {/* <div className="bl-detail-row bl-email-row">

              <div className="bl-detail-icon bl-email-icon">
                <img src="https://cdn-icons-png.flaticon.com/128/7286/7286142.png" alt="" />
              </div>

              <div className="bl-detail-copy">
                <span>Email ID</span>
                <strong>{profile?.Email || "Not Updated"}</strong>
              </div>

               <img
                src="/images/mail.png"
                alt=""
                aria-hidden="true"
                className="bl-row-bg-image bl-email-bg-image"
              />

              <button
                type="button"
                className="bl-row-action bl-email-action"
                aria-label="Edit email"
                onClick={toggleInput}
              >
                <BsPencilSquare />
              </button>

            </div> */}

            {inputOpen && (
              <div className="bl-email-editor">

                <input
                  type="email"
                  className="bl-email-input"
                  placeholder="New Email Address"
                  value={Email ?? ""}
                  onChange={handleEmailChange}
                />

                {!isValidEmail && Email && (
                  <small className="bl-email-error">
                    Please enter a valid .com email address.
                  </small>
                )}

                <button
                  type="button"
                  className="bl-email-update"
                  onClick={UpdateEmail}
                >
                  Update Email
                </button>

              </div>
            )}

            {/* KYC CARD */}
            <div
              className={`bl-detail-row bl-kyc-detail bl-detail-kyc-${kycStatus}`}
              onClick={() => {
                if (
                  kycStatus === "unverified" ||
                  kycStatus === "rejected"
                ) {
                  Kyc();
                }
              }}
              role={
                kycStatus === "unverified" || kycStatus === "rejected"
                  ? "button"
                  : undefined
              }
            >

              <div className="bl-detail-icon bl-kyc-detail-icon">
                <img src="/images/kyc.png" alt="" />
              </div>

              <div className="bl-detail-copy">
                <span>KYC Status</span>

                <strong>
                  {kycStatus === "verified"
                    ? "Verified"
                    : kycStatus === "pending"
                      ? "Pending Verification"
                      : kycStatus === "rejected"
                        ? "Verification Rejected"
                        : "Complete KYC Verification"}
                </strong>
              </div>

              {/* Decorative background image */}
              <img
                src="/images/kyc.png"
                alt=""
                aria-hidden="true"
                className="bl-row-bg-image bl-kyc-bg-image"
              />

              <div className="bl-row-status-icon">
                {kycStatus === "verified" ? (
                  <BsCheckCircle className="bl-kyc-status-check" />
                ) : kycStatus === "pending" ? (
                  <BsClockHistory className="bl-kyc-status-pending" />
                ) : (
                  <BsChevronRight className="bl-row-chevron" />
                )}
              </div>

            </div>

          </section>


          {/* Quick links shown in reference */}
          <section className="bl-quick-links bl-animate-in bl-delay-3">
            <button type="button" className="bl-quick-link bl-privacy-link" onClick={() => history.push("/history")}><BsShieldLockFill /><span>History</span><BsChevronRight /></button>
            <button type="button" className="bl-quick-link bl-notification-link" onClick={() => history.push("/refer")}><BsBellFill /><span>Refer</span><BsChevronRight /></button>
            <button type="button" className="bl-quick-link bl-support-link" onClick={() => history.push("/support")}><BsHeadset /><span>Support</span><BsChevronRight /></button>
          </section>

          {/* Logout */}
          <div className="bl-logout-wrap bl-animate-in bl-delay-3">
            <button type="button" className="bl-logout-button" onClick={logout}><MdOutlineLogout /><span>LOGOUT ACCOUNT</span></button>
          </div>


        </div>

        {/* Existing KYC modal and verification functionality preserved */}
        <Modal
          show={showKyc}
          onHide={handleCloseKyc}
          centered
          className="malik_kyc_modal kyc3d_modal"
          dialogClassName="kyc3d_dialog"
          contentClassName="kyc3d_content"
        >
          <div className="kyc3d-shell">
            {/* Animated background effects */}
            <div className="kyc3d-glow kyc3d-glow-one" />
            <div className="kyc3d-glow kyc3d-glow-two" />
            <div className="kyc3d-particles">
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>

            {/* Top decorative border */}
            <div className="kyc3d-top-border" />

            {/* Header */}
            <div className="kyc3d-header">
              <button
                type="button"
                className="kyc3d-close"
                onClick={handleCloseKyc}
                aria-label="Close verification"
              >
                ×
              </button>

              <div className="kyc3d-crown">
                <ShieldCheck size={34} strokeWidth={1.8} />
                <span className="kyc3d-crown-sparkle">✦</span>
              </div>

              {/* <h2 className="kyc3d-title">
                <span>Complete Your KYC</span>
              </h2> */}


            </div>

            {/* Online / Offline Tabs */}
            <div className="kyc3d-tabs">
              {SData?.onlineKYC && (
                <button
                  type="button"
                  className={`kyc3d-tab ${activeKycTab === "online" ? "active" : ""
                    }`}
                  onClick={() => setActiveKycTab("online")}
                >
                  <UserRound size={20} />
                  <span>Online</span>
                </button>
              )}

              {SData?.offlineKYC && (
                <button
                  type="button"
                  className={`kyc3d-tab ${activeKycTab === "offline" ? "active" : ""
                    }`}
                  onClick={() => setActiveKycTab("offline")}
                >
                  <FileText size={20} />
                  <span>Offline KYC</span>
                </button>
              )}
            </div>

            {/* Form Content */}
            <div className="kyc3d-body">
              {activeKycTab === "online" && SData?.onlineKYC && (
                <div className="kyc3d-form-panel">
                  <div className="kyc3d-section-heading">
                    <div className="kyc3d-section-icon">
                      <Fingerprint size={22} />
                    </div>

                    <div>
                      <h3>Aadhaar Verification</h3>
                      <p>Verify your identity using Aadhaar OTP</p>
                    </div>
                  </div>

                  {/* Aadhaar Number */}
                  <div className="kyc3d-field">
                    <label htmlFor="kyc3d-aadhaar">Aadhaar Number</label>

                    <div className="kyc3d-input-wrap">
                      <Fingerprint className="kyc3d-input-icon" size={21} />

                      <input
                        id="kyc3d-aadhaar"
                        type="text"
                        inputMode="numeric"
                        autoComplete="off"
                        maxLength={12}
                        className="kyc3d-input"
                        value={AadharNum}
                        onChange={handleAdharChnage}
                        placeholder="Enter 12 digit Aadhaar"
                      />

                      <span className="kyc3d-input-decoration" />
                    </div>

                    {msg && <p className="kyc3d-error">{msg}</p>}
                  </div>

                  {/* Send OTP */}
                  {!userAdharData?.request_id && (
                    <button
                      type="button"
                      className="kyc3d-button kyc3d-button-primary"
                      onClick={AdharNumber}
                      disabled={isLoading}
                    >
                      <Send size={19} />

                      <span>{isLoading ? "Sending OTP..." : "Send OTP"}</span>

                      <span className="kyc3d-button-shine" />
                    </button>
                  )}

                  {isLoading && (
                    <div className="kyc3d-loader">
                      <img
                        src="/images/LandingPage_img/loader1.gif"
                        width="34"
                        height="34"
                        alt="Loading"
                      />
                      <span>Processing your request...</span>
                    </div>
                  )}

                  {/* OTP Section */}
                  {userAdharData?.request_id && (
                    <div className="kyc3d-otp-card">
                      <div className="kyc3d-otp-heading">
                        <div className="kyc3d-section-icon kyc3d-otp-icon">
                          <LockKeyhole size={20} />
                        </div>

                        <div>
                          <h3>Enter OTP</h3>
                          <p>Enter the OTP you received</p>
                        </div>
                      </div>

                      <div className="kyc3d-field">
                        <label htmlFor="kyc3d-otp">Verification OTP</label>

                        <div className="kyc3d-input-wrap">
                          <LockKeyhole
                            className="kyc3d-input-icon"
                            size={20}
                          />

                          <input
                            id="kyc3d-otp"
                            type="text"
                            inputMode="numeric"
                            autoComplete="one-time-code"
                            maxLength={6}
                            className="kyc3d-input"
                            value={AadharOtp}
                            onChange={handleAdharOtpChnage}
                            placeholder="Enter OTP"
                          />
                        </div>
                      </div>

                      <button
                        type="button"
                        className="kyc3d-button kyc3d-button-success"
                        onClick={AdharOtpFunc}
                      >
                        <ShieldCheck size={21} />
                        <span>Submit OTP</span>
                        <span className="kyc3d-button-shine" />
                      </button>
                    </div>
                  )}

                  <div className="kyc3d-security-note">
                    <ShieldCheck size={17} />
                    <span>Your verification details are protected.</span>
                  </div>
                </div>
              )}

              {/* Offline KYC */}
              {activeKycTab === "offline" && SData?.offlineKYC && (
                <div className="kyc3d-form-panel">
                  <div className="kyc3d-section-heading">
                    <div className="kyc3d-section-icon">
                      <IdCard size={22} />
                    </div>

                    <div>
                      <h3>Offline Verification</h3>
                      <p>Submit your details and identity documents</p>
                    </div>
                  </div>

                  {/* Full Name */}
                  <div className="kyc3d-field">
                    <label htmlFor="kyc3d-name">Full Name</label>

                    <div className="kyc3d-input-wrap">
                      <UserRound className="kyc3d-input-icon" size={20} />

                      <input
                        id="kyc3d-name"
                        type="text"
                        className="kyc3d-input"
                        placeholder="Enter full name"
                        value={Names}
                        onChange={(e) => setNames(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Aadhaar */}
                  <div className="kyc3d-field">
                    <label htmlFor="kyc3d-offline-aadhaar">
                      Aadhaar Number
                    </label>

                    <div className="kyc3d-input-wrap">
                      <Fingerprint
                        className="kyc3d-input-icon"
                        size={20}
                      />

                      <input
                        id="kyc3d-offline-aadhaar"
                        type="text"
                        inputMode="numeric"
                        maxLength={12}
                        className="kyc3d-input"
                        placeholder="Enter Aadhaar number"
                        value={AadharNum}
                        onChange={handleAdharChnage}
                      />
                    </div>

                    {msg && <p className="kyc3d-error">{msg}</p>}
                  </div>

                  {/* Date of Birth */}
                  <div className="kyc3d-field">
                    <label htmlFor="kyc3d-dob">Date of Birth</label>

                    <div className="kyc3d-input-wrap">
                      <CalendarDays
                        className="kyc3d-input-icon"
                        size={20}
                      />

                      <input
                        id="kyc3d-dob"
                        type="date"
                        className="kyc3d-input kyc3d-date-input"
                        value={DOB}
                        onChange={(e) => setDob(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Front Photo */}
                  <div className="kyc3d-upload-card">
                    <div className="kyc3d-upload-icon">
                      <ImageIcon size={23} />
                    </div>

                    <div className="kyc3d-upload-info">
                      <strong>Front Photo</strong>
                      <span>Upload front side of Aadhaar</span>
                    </div>

                    <label
                      className="kyc3d-upload-button"
                      htmlFor="kyc3d-front-photo"
                    >
                      <UploadCloud size={17} />
                      <span>Upload</span>
                    </label>

                    <input
                      id="kyc3d-front-photo"
                      type="file"
                      accept="image/*"
                      onChange={(e) => setFrontLoaded(e.target.files)}
                      className="kyc3d-file-hidden"
                    />
                  </div>

                  {/* Back Photo */}
                  <div className="kyc3d-upload-card">
                    <div className="kyc3d-upload-icon">
                      <ImageIcon size={23} />
                    </div>

                    <div className="kyc3d-upload-info">
                      <strong>Back Photo</strong>
                      <span>Upload back side of Aadhaar</span>
                    </div>

                    <label
                      className="kyc3d-upload-button"
                      htmlFor="kyc3d-back-photo"
                    >
                      <UploadCloud size={17} />
                      <span>Upload</span>
                    </label>

                    <input
                      id="kyc3d-back-photo"
                      type="file"
                      accept="image/*"
                      onChange={(e) => setBackLoaded(e.target.files)}
                      className="kyc3d-file-hidden"
                    />
                  </div>

                  <button
                    type="button"
                    className="kyc3d-button kyc3d-button-gold"
                    onClick={handleSubmitdata}
                  >
                    <CheckCircle2 size={21} />
                    <span>Submit Verification</span>
                    <span className="kyc3d-button-shine" />
                  </button>

                  <div className="kyc3d-security-note">
                    <ShieldCheck size={17} />
                    <span>Please upload clear, readable document photos.</span>
                  </div>
                </div>
              )}
            </div>

            {/* Bottom decorative border */}
            <div className="kyc3d-bottom-border">
              <span />
              <i>✦</i>
              <span />
            </div>
          </div>
        </Modal>
      </div>

      <div className="rightContainer"><Rightcontainer /></div>
    </>
  );
};

export default Profile1;
